import Image from 'next/image';
import Link from 'next/link';
import { getEdgeUrl } from '@/lib/getEdgeUrl';
import i18n from '@/settings/i18n';

const t = i18n.init('homepage');

const leftSection = getEdgeUrl(
  'images/homepage/banner/holidays/holidays/christmas-left-desktop-2025.png',
);
const rightSection = getEdgeUrl(
  'images/homepage/banner/holidays/holidays/christmas-desktop-right-2025.png',
);
const leftSectionMobile = getEdgeUrl(
  'images/homepage/banner/holidays/holidays/christmas-left-mobile-2025.png',
);
const rightSectionMobile = getEdgeUrl(
  'images/homepage/banner/holidays/holidays/christmans-right-mobile-2025.png',
);

const ChristmasHero = () => (
  <Link
    href="/collections/hot-deals"
    prefetch
    className="relative flex h-full w-screen flex-col items-center justify-center overflow-hidden bg-[radial-gradient(at_center,_#D7394A,_#C84751)] text-white"
  >
    {/* Left Block  */}
    <div className="absolute bottom-0 hidden md:left-[-300px] md:block lg:left-[-170px] xl:left-[-50px]">
      <div className="h-[280px]">
        <Image
          src={leftSection}
          alt="Left Section"
          loading="eager"
          height={800}
          width={800}
          className="h-full w-auto"
          priority
        />
      </div>
    </div>
    {/* Right Block */}
    <div className="absolute top-0 hidden md:right-[-230px] md:block lg:right-[-40px] xl:right-0">
      <div className="h-[280px]">
        <Image
          src={rightSection}
          alt="Right Section"
          loading="eager"
          height={800}
          width={800}
          className="h-full w-auto"
          priority
        />
      </div>
    </div>
    {/* Left Mobile */}
    <div className="absolute bottom-0 left-[-30px] xxs:left-0 md:hidden">
      <div className="h-[280px]">
        <Image
          src={leftSectionMobile}
          alt="Left Section"
          loading="eager"
          height={800}
          width={800}
          className="h-full w-auto object-cover"
          priority
        />
      </div>
    </div>
    {/* Right Mobile */}
    <div className="absolute bottom-0 right-[-50px] xxs:right-0 md:hidden">
      <div className="h-[280px]">
        <Image
          src={rightSectionMobile}
          alt="Right Section"
          loading="eager"
          height={800}
          width={800}
          className="h-full w-auto"
          priority
        />
      </div>
    </div>
    <div className="relative">
      <div className="reebelo-container">
        <div className="flex flex-col items-center justify-center">
          <h1 className="mt-1.5 text-center text-xl font-bold leading-tight xxs:text-2xl md:text-3xl">
            {t`Holiday Deals`}
          </h1>
          <p className="text-center text-sm font-light md:text-base">
            {t`Refurbished Gifts Up To 70% Off`}
          </p>
          <div className="mt-3 flex items-center justify-center rounded-full border-2 border-gray-700 !bg-gray-700 px-5 py-2 text-xs font-semibold text-white">
            {t`Shop Deals`}
          </div>
        </div>
      </div>
    </div>
  </Link>
);

export default ChristmasHero;
